import React, { useEffect, useState } from "react";
import { AssetEditApi } from "../../../services/AssetService";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Stepper, Step, StepLabel } from "@mui/material";
import FileUpload from "../../Constant/fileupload";
import styles from "../../../assets/scss/core/utilites/assetStepperForm.module.scss";
import { CustomTooltip } from "../../../components/CustomTooltip";
import { FaInfo } from "react-icons/fa";
import Select from "react-select";
import { searchcategoryOptionApi } from "../../../services/SearchService";
import { parse, format, isValid } from "date-fns";
const steps = ["Basic Info", "Warranty & Service", "Insurance"];
const assetKeyMap = {
  assetName: "name",
  catagory: "category",
  sub_catagory: "sub_category",
  other_info: "unit_other_details",
  purchaseCost: "purchase_cost",
  purchaseDate: "purchase_date",
  assetId: "manual_asset_id",
  warrantyEnd: "warranty_end_date",
  insuranceProvider: "insurance_provider",
  policyNumber: "policy_number",
  insuranceExpiry: "insurance_expiry",
  lifespan: "expected_lifespan_months",
  scrapValue: "scrap_value",
  depreciation_method: "depreciation_method",
  depreciationRate: "depreciation_rate",
  serviceCycle: "service_cycle_months",
  manufacturer: "manufacturer",
  brand: "brand",
  modelNumber: "model_number",
  serialNumber: "serial_number",
  warrantyFile: "warranty_file",
  insuranceFile: "insurance_file",
  image: "unit_image",
};
const AssetEditModal = ({ data, visible, onClose, afterSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  //catagory
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [filteredSubCategoryOptions, setFilteredSubCategoryOptions] = useState(
    []
  );

  useEffect(() => {
    if (data && visible) {
      const matchedCategory = categoryOptions.find(
        (cat) => cat.label === data?.category
      );

      const filteredSubCategories = subCategoryOptions.filter(
        (sub) => sub.categoryId === matchedCategory?.value
      );

      const matchedSubCategory = filteredSubCategories.find(
        (sub) => sub.label === data?.sub_category
      );

      setForm({
        assetName: data?.name || "",
        catagory: matchedCategory?.value || null,
        sub_catagory: matchedSubCategory?.value || null,
        other_info: data?.unit_other_details || "",
        purchaseCost: data?.purchase_cost || "",
        purchaseDate: data?.purchase_date || "",
        assetId: data?.manual_asset_id || "",
        manufacturer: data?.manufacturer || "",
        brand: data?.brand || "",
        modelNumber: data?.model_number || "",
        serialNumber: data?.serial_number || "",
        warrantyEnd: data?.warranty?.warranty_end_date
          ? format(
              parse(data.warranty.warranty_end_date, "dd MMM yyyy", new Date()),
              "yyyy-MM-dd"
            )
          : "",
        serviceCycle: data?.service_cycle_months || "",
        lifespan: data?.expected_lifespan_months || "",
        depreciationRate: data?.depreciation?.depreciation_rate || "",
        scrapValue: data?.scrap_value || "",
        insuranceProvider: data?.insurance?.insurance_provider || "",
        policyNumber: data?.insurance?.policy_number || "",
        insuranceExpiry: data?.insurance?.insurance_expiry
          ? (() => {
              const parsed = parse(
                data.insurance.insurance_expiry,
                "dd MMM yyyy",
                new Date()
              );
              return isValid(parsed) ? format(parsed, "yyyy-MM-dd") : "";
            })()
          : "",
        depreciation_method: data?.depreciation?.depreciation_method || "",
        // image: data?.unit_image || null,
        // insuranceFile: data?.insurance?.insurance_attachment || null,
        // warrantyFile: data?.warranty?.warranty_attachment || null,
        image:null,
        insuranceFile:null,
        warrantyFile:null,
      });
      setSelectedCategory(matchedCategory || null);
      setFilteredSubCategoryOptions(filteredSubCategories);
      setSelectedSubCategory(matchedSubCategory || null);

      setActiveStep(0);
      setErrors({});
    } else {
      handleRresetAsset();
    }
  }, [data, visible, categoryOptions, subCategoryOptions]);

  const handleRresetAsset = () => {
    setForm({
      assetName: "",
      catagory: null,
      sub_catagory: null,
      other_info: "",
      purchaseCost: "",
      purchaseDate: "",
      assetId: "",
      manufacturer: "",
      brand: "",
      modelNumber: "",
      serialNumber: "",
      warrantyEnd: "",
      warrantyFile: null,
      serviceCycle: "",
      lifespan: "",
      depreciationRate: "",
      scrapValue: "",
      insuranceProvider: "",
      policyNumber: "",
      insuranceExpiry: "",
      depreciatio_method: "",
      insuranceFile: null,
      image: null,
    });
    setActiveStep(0);
    setErrors({});
    setSelectedCategory(null);
    setSelectedSubCategory(null);
    setFilteredSubCategoryOptions(subCategoryOptions);
  };

  useEffect(() => {
    if (visible) {
      searchcategoryOptionApi()
        .then((res) => {
          if (res?.data?.results) {
            const categoryOpts = res.data.results.map((item) => ({
              label: item.name,
              value: item.id,
              subcategories: item.subcategories || [],
            }));
            setCategoryOptions(categoryOpts);

            const allSubCats = categoryOpts.flatMap((cat) =>
              cat.subcategories.map((sub) => ({
                label: sub.name,
                value: sub.id,
                categoryId: cat.value,
              }))
            );

            setSubCategoryOptions(allSubCats);
            setFilteredSubCategoryOptions(allSubCats);
          }
        })
        .catch((err) => console.error("Category fetch failed:", err));
    }
  }, [visible]);

  const handleInput = (e) => {
    const { name, value, type, files } = e.target;

    if ((name === "scrapValue" || name === "lifespan") && !value) {
      setForm((prev) => ({
        ...prev,
        [name]: value,
        depreciation_method: "",
        depreciationRate: "",
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: type === "file" ? files[0] : value,
      }));
    }

    if (value && errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleNext = () => {
    const newErrors = {};

    if (activeStep === 0) {
      if (!form.assetName) newErrors.assetName = true;
      if (!form.purchaseCost) newErrors.purchaseCost = true;
      if (!form.purchaseDate) newErrors.purchaseDate = true;
      if (!form.catagory) newErrors.catagory = true;
      if (!form.sub_catagory) newErrors.sub_catagory = true;
    }

    if (activeStep === 1) {
      const hasWarranty =
        form.serviceCycle || form.warrantyEnd || form.warrantyFile;
      if (hasWarranty) {
        if (!form.serviceCycle) newErrors.serviceCycle = true;

        if (!form.warrantyEnd) newErrors.warrantyEnd = true;
      }
      const hasDepreciation =
        // form.depreciationRate ||
        form.scrapValue || form.lifespan;
      if (hasDepreciation) {
        if (!form.lifespan) newErrors.lifespan = true;
        // if (!form.depreciationRate) newErrors.depreciationRate = true;
        if (!form.scrapValue) newErrors.scrapValue = true;
      }
    }

    if (activeStep === 2) {
      const hasInsurance =
        form.insuranceProvider ||
        form.policyNumber ||
        form.insuranceExpiry ||
        form.insuranceFile;
      if (hasInsurance) {
        if (!form.insuranceProvider) newErrors.insuranceProvider = true;
        if (!form.policyNumber) newErrors.policyNumber = true;
        if (!form.insuranceExpiry) newErrors.insuranceExpiry = true;
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      if (activeStep === steps.length - 1) {
        handleConfirm();
      } else {
        setActiveStep((prev) => prev + 1);
      }
    }
  };

  const handleBack = () => {
    setErrors({});
    setActiveStep((prev) => prev - 1);
  };

  const handleCategoryChange = (selected) => {
    if (selected?.value) {
      setErrors({ ...errors, catagory: false });
    }
    setSelectedCategory(selected);
    setSelectedSubCategory(null);
    setForm({ ...form, catagory: selected || null, sub_catagory: null });
    const filtered = subCategoryOptions.filter(
      (sub) => sub.categoryId === selected.value
    );
    setFilteredSubCategoryOptions(filtered);
  };

  const handleSubCategoryChange = (selected) => {
    if (selected?.value) {
      setErrors({ ...errors, sub_catagory: false });
    }
    setSelectedSubCategory(selected);
    setForm({ ...form, sub_catagory: selected || null });

    if (!selectedCategory || selected.categoryId !== selectedCategory.value) {
      const relatedCat = categoryOptions.find(
        (cat) => cat.value === selected.categoryId
      );
      setSelectedCategory(relatedCat);
      setForm({ ...form, catagory: relatedCat || null });

      const filtered = subCategoryOptions.filter(
        (sub) => sub.categoryId === relatedCat?.value
      );
      setFilteredSubCategoryOptions(filtered);
    }
  };
  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <div className="row gy-2">
            <div className="col-md-4">
              <label className="form-label text-dark">Asset Name</label>
              <span className="text-danger fw-medium ms-1">*</span>
              <input
                name="assetName"
                className="form-control"
                value={form.assetName}
                onChange={handleInput}
                placeholder="e.g. Asus Zen Book"
              />
              {errors?.assetName && (
                <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                  Mandatory Field
                </div>
              )}
            </div>{" "}
            <div className="col-md-4">
              <label className="form-label text-dark">Catagory</label>
              <span className="text-danger fw-medium ms-1">*</span>
              <Select
                options={categoryOptions}
                classNamePrefix="select"
                className="react-select"
                placeholder="Electronics"
                onChange={handleCategoryChange}
                value={selectedCategory}
              />
              {errors?.catagory && (
                <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                  Please select catagory
                </div>
              )}
            </div>{" "}
            <div className="col-md-4">
              <label className="form-label text-dark">Sub-Category</label>
              <span className="text-danger fw-medium ms-1">*</span>
              <Select
                options={filteredSubCategoryOptions}
                classNamePrefix="select"
                className="react-select"
                placeholder="Laptop"
                onChange={handleSubCategoryChange}
                value={selectedSubCategory}
              />
              {errors?.sub_catagory && (
                <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                  Please select a Subcategory
                </div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Purchase Date</label>
              <span className="text-danger fw-medium ms-1">*</span>
              <input
                name="purchaseDate"
                type="date"
                className={`form-control ${
                  errors.purchaseDate ? "is-invalid" : ""
                }`}
                value={form.purchaseDate}
                onChange={handleInput}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Purchase Cost</label>
              <span className="text-danger fw-medium ms-1">*</span>
              <input
                name="purchaseCost"
                type="text"
                className={`form-control ${
                  errors.purchaseCost ? "is-invalid" : ""
                }`}
                value={form.purchaseCost}
                placeholder="e.g 30000"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleInput(e);
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Manual Asset ID</label>
              <CustomTooltip
                title="Manual Asset ID is the pre-existing code physically tagged on the asset (e.g., barcode, RFID tag, serial tag). Ensure it’s unique and correctly entered."
                arrow
                placement="right"
              >
                <span
                  className="rounded-2 ms-1 btn btn-sm btn-outline-light"
                  style={{ cursor: "pointer", padding: "0.2rem 0.2rem" }}
                >
                  <FaInfo size={10} className="text-dark" />
                </span>
              </CustomTooltip>
              <input
                name="assetId"
                type="text"
                className="form-control"
                value={form.assetId}
                onChange={handleInput}
                placeholder="e.g. AST-00123"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Manufacturer</label>
              <input
                name="manufacturer"
                className="form-control"
                value={form.manufacturer}
                onChange={handleInput}
                placeholder="e.g. Hewlett-Packard"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Brand</label>
              <input
                name="brand"
                className="form-control"
                value={form.brand}
                onChange={handleInput}
                placeholder="e.g. HP"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Model Number</label>
              <input
                name="modelNumber"
                className="form-control"
                value={form.modelNumber}
                onChange={handleInput}
                placeholder="e.g. 840-G6"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Serial Number</label>
              <input
                name="serialNumber"
                className="form-control"
                value={form.serialNumber}
                onChange={handleInput}
                placeholder="e.g. SN-1234567890"
              />
            </div>
            <div className="col-md-8">
              <label className="form-label text-dark">Other Information</label>
              <input
                name="other_info"
                className="form-control"
                value={form.other_info}
                onChange={handleInput}
                placeholder="Type other info of this asset"
              />
            </div>
          </div>
        );

      case 1:
        return (
          <>
            <div className="row gy-2">
              <div className="col-md-4">
                <label className="form-label text-dark">
                  Service Cycle (months)
                </label>
                <div className="position-relative overflow-hidden">
                  <input
                    name="serviceCycle"
                    type="text"
                    pattern="[0-9]*"
                    placeholder="e.g. 12"
                    className={`form-control ${
                      errors.serviceCycle ? "is-invalid" : ""
                    }`}
                    value={form.serviceCycle}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInput(e);
                      }
                    }}
                  />
                  {form.serviceCycle && parseInt(form.serviceCycle) > 0 && (
                    <div
                      className="position-absolute top-50 translate-middle-y small px-2 py-1 rounded"
                      style={{
                        right: "0px",
                        fontSize: "0.8rem",
                        lineHeight: "1",
                        pointerEvents: "none",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span>
                        {(parseInt(form.serviceCycle) / 12)
                          .toFixed(1)
                          .replace(/\.0$/, "")}{" "}
                        year{parseInt(form.serviceCycle) >= 24 ? "s" : ""}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label text-dark">
                  Warranty End Date
                </label>
                <input
                  name="warrantyEnd"
                  type="date"
                  className={`form-control ${
                    errors.warrantyEnd ? "is-invalid" : ""
                  }`}
                  value={form.warrantyEnd}
                  onChange={handleInput}
                  min={
                    new Date(Date.now() + 86400000).toISOString().split("T")[0]
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label text-dark">
                  Lifespan (months)
                </label>
                <div className="position-relative">
                  <input
                    name="lifespan"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="e.g. 12"
                    className={`form-control ${
                      errors.lifespan ? "is-invalid" : ""
                    }`}
                    value={form.lifespan}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInput(e);
                      }
                    }}
                  />
                  {form.lifespan && parseInt(form.lifespan) > 0 && (
                    <div
                      className="position-absolute top-50 translate-middle-y small px-2 py-1 rounded"
                      style={{
                        right: "0px",
                        fontSize: "0.8rem",
                        lineHeight: "1",
                        pointerEvents: "none",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span>
                        {(parseInt(form.lifespan) / 12)
                          .toFixed(1)
                          .replace(/\.0$/, "")}{" "}
                        year{parseInt(form.lifespan) >= 24 ? "s" : ""}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label text-dark">Scrap Value</label>
                <input
                  name="scrapValue"
                  type="text"
                  placeholder="e.g. 5000"
                  className={`form-control ${
                    errors.scrapValue ? "is-invalid" : ""
                  }`}
                  value={form.scrapValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleInput(e);
                    }
                  }}
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-4">
                <span className="form-label text-dark">
                  Depreciation Method
                </span>
                <div className="d-flex gap-2 align-items-center mt-2">
                  <div className="form-check form-check-inline p-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="depreciation_method"
                      value="SLM"
                      id="slm"
                      disabled={!(form.scrapValue && form.lifespan)}
                      checked={form.depreciation_method == "SLM"}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          depreciation_method: e.target.value,
                          depreciationRate: "",
                        }))
                      }
                      style={{
                        width: "16px",
                        height: "16px",
                      }}
                    />
                    <label
                      className="form-check-label text-dark fw-medium"
                      htmlFor="slm"
                      style={{ fontSize: "0.9rem" }}
                    >
                      SLM
                    </label>
                  </div>

                  <div className="form-check form-check-inline p-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="depreciation_method"
                      value="RBM"
                      id="rbm"
                      disabled={!(form.scrapValue && form.lifespan)}
                      checked={form.depreciation_method == "RBM"}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          depreciation_method: e.target.value,
                          depreciationRate: "",
                        }))
                      }
                      style={{
                        width: "16px",
                        height: "16px",
                      }}
                    />
                    <label
                      className="form-check-label text-dark fw-medium"
                      htmlFor="rbm"
                      style={{ fontSize: "0.9rem" }}
                    >
                      RBM
                    </label>
                  </div>
                </div>
              </div>

              {form.depreciation_method == "RBM" && (
                <div className="col-md-4">
                  <label className="form-label text-dark">
                    Depreciation Rate (per month)
                  </label>
                  <input
                    name="depreciationRate"
                    type="text"
                    placeholder="e.g. 15%"
                    className={`form-control ${
                      errors.depreciationRate ? "is-invalid" : ""
                    }`}
                    value={form.depreciationRate || 0}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInput(e);
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </>
        );

      case 2:
        return (
          <div className="row">
            <div className="col-md-4">
              <label className="form-label text-dark">Insurance Provider</label>
              <input
                name="insuranceProvider"
                placeholder="e.g. ICICI Lombard"
                className={`form-control ${
                  errors.insuranceProvider ? "is-invalid" : ""
                }`}
                value={form.insuranceProvider}
                onChange={handleInput}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Policy Number</label>
              <input
                name="policyNumber"
                className={`form-control ${
                  errors.policyNumber ? "is-invalid" : ""
                }`}
                value={form.policyNumber}
                onChange={handleInput}
                placeholder="e.g. POL-123456789"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label text-dark">Expiry Date</label>
              <input
                name="insuranceExpiry"
                type="date"
                className={`form-control ${
                  errors.insuranceExpiry ? "is-invalid" : ""
                }`}
                value={form.insuranceExpiry}
                onChange={handleInput}
                placeholder="Select insurance expiry date"
                min={
                  new Date(Date.now() + 86400000).toISOString().split("T")[0]
                }
              />
            </div>
            {/* <div className="col-md-4 my-2" style={{ minHeight: "150px" }}>
              <label className="form-label text-dark">Insurance File</label>
              <FileUpload
                label="Upload File maxisze 5Mb"
                accept=".pdf"
                multiple={false}
                value={form.insuranceFile}
                onChange={(files) =>
                  setForm((prev) => ({ ...prev, insuranceFile: files }))
                }
              />
            </div>
            <div className="col-md-4 my-2" style={{ minHeight: "150px" }}>
              <label className="form-label text-dark">Asset Image</label>
              <FileUpload
                label="Upload File maxisze 5Mb"
                accept=".jpg,.jpeg,.png"
                multiple={false}
                value={form.image}
                onChange={(files) =>
                  setForm((prev) => ({ ...prev, image: files }))
                }
              />
            </div>
            <div className="col-md-4 my-2" style={{ minHeight: "150px" }}>
              <label className="form-label text-dark">Warenty File</label>
              <FileUpload
                label="Upload File maxisze 5Mb"
                accept=".pdf"
                multiple={false}
                value={form.warrantyFile}
                onChange={(files) => {
                  setForm((prev) => ({ ...prev, warrantyFile: files }));
                }}
              />
            </div> */}
          </div>
        );

      default:
        return null;
    }
  };

  const submitForm = (payload) => {
    setLoading(true);
    AssetEditApi(data?.id || "", payload)
      .then((res) => {
        toast.success("Asset Update Successfully");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleConfirm = () => {
    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      const mappedKey = assetKeyMap[key] || key;
      const value = form[key];
      if (value !== null && value !== undefined && value !== "") {
        if (value instanceof File) {
          formData.append(mappedKey, value);
        } else {
          formData.append(mappedKey, value);
        }
      }
    });

    submitForm(formData);
  };
  return (
    <Modal show={visible} onHide={onClose} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Edit Asset</Modal.Title>
      </Modal.Header>
      <Modal.Body className="scroll-container p-4">
        <div className="px-2 pb-3">
          <div className={styles.assetStepper}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, i) => (
                <Step key={i}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
          {renderStep()}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-between gap-2 w-100">
          <div className="d-flex gap-2">
            <button
              className="btn btn-danger rounded-2 align-self-center"
              style={{ padding: "0.4rem 1.1rem" }}
              onClick={() => {
                handleRresetAsset();
              }}
            >
              Reset
            </button>
          </div>
          <div className="d-flex gap-2">
            {activeStep > 0 && (
              <button
                className="btn  rounded-2 stylish-transparent-btn align-self-center"
                style={{ padding: "0.4rem 1.1rem" }}
                onClick={handleBack}
              >
                Back
              </button>
            )}
            <button
              className="btn rounded-2 btn-info align-self-center"
              style={{ padding: "0.4rem 1.1rem" }}
              onClick={handleNext}
              disabled={loading}
            >
              {loading && <Spinner animation="border" size="sm" />}
              {activeStep === steps.length - 1 ? "Save Asset" : "Next"}
            </button>
            {/* <span
              className="btn btn-outline-danger align-self-center"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary align-self-center"
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Submit
            </button> */}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AssetEditModal;
